import { useMemo, type CSSProperties } from "react";

const STAR_COUNT = 28;

const TAIL_ANGLE = 135;

type StarSpec = {
  id: number;
  left: number;
  drift: number;
  angle: number;
  delay: number;
  duration: number;
  tail: number;
  opacity: number;
  size: number;
  hue: number;
};

function createStars(): StarSpec[] {
  return Array.from({ length: STAR_COUNT }, (_, id) => ({
    id,
    left: Math.random() * 100,
    drift: (Math.random() - 0.5) * 10,
    angle: TAIL_ANGLE + (Math.random() - 0.5) * 12,
    delay: Math.random() * 14,
    duration: 2.8 + Math.random() * 4.5,
    tail: 48 + Math.random() * 90,
    opacity: 0.28 + Math.random() * 0.55,
    size: 1 + Math.random() * 1.5,
    hue: 190 + Math.random() * 80,
  }));
}

export function FallingStars() {
  const stars = useMemo(createStars, []);

  return (
    <div className="landing__stars" aria-hidden="true">
      {stars.map(star => (
        <span
          key={star.id}
          className="landing__star"
          style={
            {
              left: `${star.left}%`,
              "--star-drift": `${star.drift}vw`,
              "--star-tail-rotate": `${star.angle}deg`,
              "--star-delay": `${star.delay}s`,
              "--star-duration": `${star.duration}s`,
              "--star-tail": `${star.tail}px`,
              "--star-opacity": String(star.opacity),
              "--star-size": `${star.size}px`,
              "--star-hue": String(star.hue),
            } as CSSProperties
          }
        />
      ))}
    </div>
  );
}
